<app-aggregated-amount-item
  name="ハッシュタグ"
  icon="./assets/instagram_hashtag.png"
  amount="{{ (instagramHashtagCountModel$ | async)?.units }}"
  hasAmount="{{ (instagramHashtagCountModel$ | async)?.hasUnits }}"
  unit="投稿数"
  [rate]="(instagramHashtagCountModel$ | async)?.rate"
  link=""
  help="選択期間内に取得できた最新の値を表示しています。Instagramにおける次のハッシュタグの投稿数の合計です。【{{
    (instagramHashtagCountModel$ | async)?.hashtag
  }}】"
  [loading]="loading$ | async"
  [dataCollections]="dataCollections$ | async"
  [dataCollectLoading]="dataCollectLoading$ | async"
  [isDecimal]="true"
></app-aggregated-amount-item>
